import { render, staticRenderFns } from "./SubportalLayout.vue?vue&type=template&id=421fbd6f&"
import script from "./SubportalLayout.ts?vue&type=script&lang=ts&"
export * from "./SubportalLayout.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports